import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";
import RefreshableInterface from "./utils/RefreshableInterface";
import {Grid, OpenDialog} from "../index";
import Dialog from "./modal/Dialog";
import {DceAjax} from "../../../dce-ajax";
import LoadableInterface from "./utils/LoadableInterface";

interface SecondCompProps {
    label: string;
}

@Dce("Workspace")
export default class Workspace extends DceComponent<SecondCompProps> {

    private logger = Logger.of("Workspace");

    private refreshable: RefreshableInterface;
    private loadable: LoadableInterface;

    constructor(elem: DceHTMLElement, props: SecondCompProps) {
        super(elem, props);
        this.logger.debug("Workspace");
    }

    onSubComponentInit(component: string, elem: DceHTMLElement) {

        if(component == 'Grid'){
            this.logger.debug("Grid", elem);
            this.refreshable = elem.ext.getComponent(component) as Grid;
            return;
        }
        
        if(elem.hasAttribute("workspace-role") && elem.getAttribute('workspace-role') == 'content'){
            let comp:any = elem.ext.getComponent(component);
            this.refreshable = comp as RefreshableInterface;
        }

        if(elem.hasAttribute("workspace-role") && elem.getAttribute('workspace-role') == 'loadable'){
            let comp:any = elem.ext.getComponent(component);
            this.loadable = comp as LoadableInterface;
        }

        if(component == 'OpenDialog'){

            if(elem.hasAttribute('data-refresh')){

                this.logger.debug("OpenDialog", elem);

                let openDialog = elem.ext.getComponent(component) as OpenDialog;
                openDialog.addOnClose((d, e) => this.dialogClose(d, e));

            }

        }

    }

    private callAndRefresh(e: Event){

        e.preventDefault();

        let elem = e.target as HTMLElement;

        DceAjax.getInstance()
            .get(elem.getAttribute('href'))
            .then(resp => {
                if(resp.isValid()){
                    if(this.refreshable){
                        this.refreshable.refresh();
                    }
                }
            });

    }

    private dialogClose(d:Dialog, e:HTMLElement){
        //robimy refresha dla okienek bez formularza i dla zapisanych formularzy
        this.logger.debug("Dialog close", d.getFormBind(), d.getFormSaved())

        if (d.dialogIsNextStep || (!d.getFormBind() || (d.getFormBind() && d.getFormSaved()))) {
            this.logger.debug("REFRESHING GRIIIIIIIIIIIIIIID :)");
            if(this.refreshable) {
                this.refreshable.refresh();
            }

            if(this.loadable && d.getFormResponse()){
                this.logger.debug("MAMU RELOADABLE");

                if( d.getFormResponse().hasData('loadUrl') ){

                    this.logger.debug("LOAAAD URL: " + d.getFormResponse().getData('loadUrl'));

                    this.loadable.loadUrl(
                        d.getFormResponse().getData('loadUrl')
                    );

                }
            }

        }

    }

}
